export default __webpack_public_path__ + "static/media/ideation.fa1af174.svg";